export default [
  {
    path: '/distributor/buyorderlist',
    name: 'distributor',
    meta: {
      index: 1
    },
    component: () => import(/* webpackChunkName: "distributor" */ '../../pages/distributor/my-performance/buyorderlist.vue')
  }
]
